function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "noun_id_1707527",
  transform: "translate(82)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_34",
  "data-name": "Path 34",
  d: "M16.13,976.362A9.11,9.11,0,0,0,7,985.493v60.87a9.11,9.11,0,0,0,9.13,9.13H128.739a9.11,9.11,0,0,0,9.13-9.13v-60.87a9.11,9.11,0,0,0-9.13-9.13ZM42,996.145a9.13,9.13,0,1,1-9.13,9.13A9.13,9.13,0,0,1,42,996.145Zm35,0h45.652a3.043,3.043,0,1,1,0,6.087H77a3.043,3.043,0,1,1,0-6.087Zm0,16.739h45.652a3.044,3.044,0,0,1,0,6.087H77a3.044,3.044,0,0,1,0-6.087Zm-35,7.609c10.96,0,19.783,5.828,19.783,12.7v2.52H22.217v-2.52C22.217,1026.32,31.04,1020.493,42,1020.493Zm35,9.13h45.652a3.043,3.043,0,1,1,0,6.087H77a3.043,3.043,0,1,1,0-6.087Z",
  transform: "translate(-7 -976.362)",
  fill: "#fff"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "add-24px",
  transform: "translate(0 4)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_305",
  "data-name": "Path 305",
  d: "M0,0H72V72H0Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_306",
  "data-name": "Path 306",
  d: "M47,29H29V47H23V29H5V23H23V5h6V23H47Z",
  transform: "translate(10 10)",
  fill: "#fff"
}));

function SvgAddRailcard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "add-railcard",
    width: 212.87,
    height: 79.13,
    viewBox: "0 0 212.87 79.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRailcard);
export default __webpack_public_path__ + "static/media/add-railcard.2c62d7c5.svg";
export { ForwardRef as ReactComponent };